import './RefreshIFrame.scss'

import * as React from 'react'

export const RefreshIFrame = React.forwardRef<HTMLIFrameElement>((_, ref) => {
  return (
    <iframe
      className="RefreshIFrame__main"
      ref={ref}
      sandbox="allow-scripts allow-same-origin"
      name="iframe-name"
      title="refresh-token-frame"
      src="/"
    />
  )
})

RefreshIFrame.displayName = 'RefreshIFrame'
